import request from '@/utils/request'

export function getData(query) {
  return request({
    url: '/index/bis/getData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getNewJobData(query) {
  return request({
    url: '/index/bis/getNewJobData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getCompanyData(query) {
  return request({
    url: '/index/bis/getCompanyData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMajorJobData(query) {
  return request({
    url: '/index/bis/getMajorJobData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getPartData(query) {
  return request({
    url: '/index/bis/getPartData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}